import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { UserRole } from '@/types/user'

interface ProtectedRouteProps {
  requiredRole?: 'admin' | 'super_admin'
}

export function ProtectedRoute({ requiredRole }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-primary-500/30 border-t-primary-500 rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) {
    // Save the attempted location so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requiredRole) {
    const hasAccess = 
      (requiredRole === 'admin' && (user.role === UserRole.ADMIN || user.role === UserRole.SUPER_ADMIN)) ||
      (requiredRole === 'super_admin' && user.role === UserRole.SUPER_ADMIN)
    
    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return <Outlet />
}